import React, { Component, PropTypes } from 'react'
import styles from './Program.css'
import { PanelGroup } from 'react-bootstrap'
import WrappedPanel from './WrappedPanel'
import ProgramType from './ProgramType'
import PointRule from './PointRule'
import Reward from './Reward'
import ProgramConfiguration from './ProgramConfiguration'
import CannotReviewModal from './CannotReviewModal'
import * as mpLoyalty from 'mixpanel/customers/loyalty'

class Program extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeKey: '1',
      isPointRuleVisited: props.isAccordionEnabled,
      isRewardVisited: props.isAccordionEnabled,
      isConfigurationVisited: props.isAccordionEnabled,
      showModalAtFirst: !props.isAccordionEnabled,
      showModal: false
    }
  }

  componentDidMount () {
    if (this.props.parentComponent === 'Create') {
      mpLoyalty.createProgramShowProgramType()
    }
  }

  render () {
    const { isPointRuleVisited, isRewardVisited, isConfigurationVisited } = this.state
    const isReviewDisabled = this._isReviewDisabled()
    let disabledReviewClass = isReviewDisabled ? styles['disabled-review-button'] + ' btn-basic' : 'btn-primary'
    return (
      <div>
        <PanelGroup activeKey={this.state.activeKey} accordion>
          <WrappedPanel
            title='1. LOYALTY PROGRAM TYPE'
            isOpened={this.state.activeKey === '1'}
            isValid
            isVisited
            eventKey={'1'}
            changeActiveKey={this._changeActiveKey}
          >
            <ProgramType onFinish={this._onFinishProgramType} />
          </WrappedPanel>
          <WrappedPanel
            title='2. POINT RULE'
            isOpened={this.state.activeKey === '2'}
            isValid={this._pointRuleValidity()}
            isVisited={isPointRuleVisited}
            eventKey={'2'}
            changeActiveKey={this._changeActiveKey}
          >
            <PointRule
              spendingAmount={this.props.spendingAmount}
              pointFromSpendingAmount={this.props.pointFromSpendingAmount}
              newMemberPoint={this.props.newMemberPoint}
              setSpendingAmount={this.props.setSpendingAmount}
              setPointFromSpendingAmount={this.props.setPointFromSpendingAmount}
              setNewMemberPoint={this.props.setNewMemberPoint}
              onFinish={this._onFinishPointRule}
            />
          </WrappedPanel>
          <WrappedPanel
            title='3. REWARD'
            isOpened={this.state.activeKey === '3'}
            isValid={this._rewardValidity()}
            isVisited={isRewardVisited}
            eventKey={'3'}
            changeActiveKey={this._changeActiveKey}
          >
            <Reward
              rewards={this.props.rewards}
              addReward={this.props.addReward}
              removeReward={this.props.removeReward}
              isOpened={this.state.activeKey === '3'}
              onFinish={this._onFinishReward}
              showModalAtFirst={this.state.showModalAtFirst}
            />
          </WrappedPanel>
          <WrappedPanel
            title='4. LOYALTY PROGRAM CONFIGURATION'
            isOpened={this.state.activeKey === '4'}
            isValid={this._configurationValidity()}
            isVisited={isConfigurationVisited}
            eventKey={'4'}
            changeActiveKey={this._changeActiveKey}
          >
            <ProgramConfiguration
              toggleSentValidationCode={this.props.toggleSentValidationCode}
              sentValidationCode={this.props.sentValidationCode}
            />
          </WrappedPanel>
        </PanelGroup>

        <div className='row'>
          <div className='col-md-6'>
            <button onClick={this.props.cancelProgram} style={{color: '#2e79b9'}} className={`btn btn-default text-center form-control`}>
              Cancel
            </button>
          </div>
          <div className='col-md-6'>
            <button onClick={this._onClickReview} className={`btn text-center form-control ${disabledReviewClass}`}>
              Review
            </button>
          </div>
        </div>

        <CannotReviewModal
          show={this.state.showModal}
          close={this._closeModal}
        />

      </div>

    )
  }

  _isReviewDisabled = () => {
    return !(
      this._pointRuleValidity() && this._rewardValidity() && this._configurationValidity() &&
      this.state.isPointRuleVisited && this.state.isRewardVisited && this.state.isConfigurationVisited
    )
  }

  _changeActiveKey = (activeKey) => {
    // currently only do tracking for create
    if (this.props.parentComponent === 'Create' && this.state.activeKey !== activeKey) {
      if (activeKey === '1') {
        mpLoyalty.createProgramShowProgramType()
      } else if (activeKey === '2') {
        mpLoyalty.createProgramShowPointRule()
      } else if (activeKey === '3') {
        mpLoyalty.createProgramShowReward()
      } else if (activeKey === '4') {
        mpLoyalty.createProgramShowConfiguration()
      }
    }

    this.setState({ activeKey })
  }

  _pointRuleValidity = () => {
    return this.props.spendingAmount >= 1000 && this.props.pointFromSpendingAmount > 0
  }

  _rewardValidity = () => {
    return this.props.rewards.length > 0
  }

  _configurationValidity = () => {
    return true
  }

  _onFinishProgramType = () => {
    this.setState({ isPointRuleVisited: true, activeKey: '2' })
    if (this.props.parentComponent === 'Create') {
      mpLoyalty.createProgramShowPointRule()
    }
  }

  _onFinishPointRule = () => {
    this.setState({ isRewardVisited: true, activeKey: '3' })
    if (this.props.parentComponent === 'Create') {
      mpLoyalty.createProgramShowReward()
    }
  }

  _onFinishReward = () => {
    this.setState({ isConfigurationVisited: true, activeKey: '4' })
    if (this.props.parentComponent === 'Create') {
      mpLoyalty.createProgramShowConfiguration()
    }
  }

  _closeModal = () => {
    this.setState({
      showModal: false
    })
  }

  _onClickReview = (e) => {
    e.stopPropagation()
    if (this._isReviewDisabled()) {
      this.setState({
        showModal: true
      })
    } else {
      this.setState({activeKey: '1'})
      this.props.showReview()
    }
  }

}

Program.propTypes = {
  spendingAmount: PropTypes.number.isRequired,
  pointFromSpendingAmount: PropTypes.func.isRequired,
  newMemberPoint: PropTypes.number.isRequired,
  setSpendingAmount: PropTypes.func.isRequired,
  setPointFromSpendingAmount: PropTypes.func.isRequired,
  sentValidationCode: PropTypes.bool.isRequired,
  toggleSentValidationCode: PropTypes.func.isRequired,
  showReview: PropTypes.func.isRequired
}

export default Program



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/Program.js